<template>
	<div class="h-full p-20px flex flex-column">
		<div class="text-center  pb-16px font-bold !text-20px" v-if="report">
			{{ report.name }}{{ map[dimension] }}
		</div>
		<div class="flex-1 bg-white-color flex flex-column !h-0px" v-if="view">
			<!-- 重分类 -->
			<!-- <component v-if="loading" :is="view" :report="report" :dimension="dimension" :isCfls="isCfls"/> -->
			<component v-if="loading" :is="view" :report="report" :dimension="dimension" :isCfls="isCfls" @update-dimension="dimension = $event"/>
		</div>
	</div>
</template>

<script>
import report from "@/api/report";
import {layer} from "@layui/layer-vue";
import ZcfzbReportView from "@/views/report/view/ZcfzbReportView";
import ZcfzbReportViews from "@/views/report/view/ZcfzbReportViews";
import XjllbReportView from "@/views/report/view/XjllbReportView";
import CwgyxxReportView from "@/views/report/view/CwgyxxReportView";
import BmlrReportView from "@/views/report/view/BmlrReportView";
import LrbReportView from "@/views/report/view/LrbReportView";
import XmlrReportView from "@/views/report/view/XmlrReportView";
import fyllrReportView from "@/views/report/view/fyllrReportView";
import EventBus from "@/js/common/EventBus";

export default {
	name: "ReportView",
	components: {XmlrReportView, LrbReportView, BmlrReportView, CwgyxxReportView, XjllbReportView, ZcfzbReportView,fyllrReportView,ZcfzbReportViews},
	props: {
		dimension: {
			type: String,
			default: 'TERM'
		},
		reportId: [String]
	},
	data() {
		return {
			isCfls: false,//重分类
			report: {},
			map: {
				"TERM": "",
				"YEAR": "",
				"QUARTER": "季报"
			},
			viewMap: {
				ndlr: 'ZcfzbReportView',//+++A
				xmlr: 'XmlrReportView',
				lr: 'ZcfzbReportView',
				bmlr: 'BmlrReportView',
				cwgyxx: 'CwgyxxReportView',
				xjll: 'ZcfzbReportView',
				zcfz: 'ZcfzbReportView',
				zcfzbcfl: 'ZcfzbReportView',
				fyllr: 'fyllrReportView',
				ns1:'ZcfzbReportViews',
				ns2:'ZcfzbReportViews',
				ns3:'ZcfzbReportViews',
				ns4:'ZcfzbReportViews',
				ns5:'ZcfzbReportViews',
				ns6:'ZcfzbReportViews',
			},
			view: null,
			loading: true
		}
	},
	created() {
		this.loadReport();
		EventBus.off("report.reload");
		//重分类
		EventBus.on("report.reload", (type) => {
			if(type == "zcfzbcfl"){
				this.isCfls = true;
			}
			this.loading = false;
			this.$nextTick(() => {
				this.loadReport();
			})
		})
	},
	methods: {
		loadReport() {
			const loadId = layer.load(2);
			report.template.load(this.reportId).then(({data}) => {
				this.report = data;
				this.loading = true;
				this.view = this.viewMap[data.templateKey];
			}).finally(() => layer.close(loadId));
		}
	},
	unmounted() {
		EventBus.off("report.reload");
	}
}
</script>
